import apiEndPoints from "../../routeConfig";
import { ApiService } from "../../../service/api.service";

const apiService = new ApiService();

export const ecosytemIntegatorCreateOrUpdate = async (data, editMode, id,) => {
  let url
  let result
  if (editMode === true) {
    url = `${apiEndPoints.ecosytemIntegatorCreateOrUpdate}/${id}`
  } else {
    url = `${apiEndPoints.ecosytemIntegatorCreateOrUpdate}`
  }
  if (editMode === true) {
    await apiService.update(url, data).then(response => {
      result = response;
    }).catch(error => {
      result = error;
    })
  } else {
    await apiService.post(url, data).then(response => {
      result = response;
    }).catch(error => {
      result = error;
    })
  }
  return result;
}

export const getAllEcosytemIntegator = async (page = 0, limit = 10) => {
  try {
    const response = await apiService.get(`${apiEndPoints.getAllEcosytemIntegator}?page=${page + 1}&limit=${limit}`,);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const ecosytemIntegatorGetById = async (id) => {
  let result;
  await apiService.get(`${apiEndPoints.ecosytemIntegatorGetById}/${id}`)
    .then((response) => {
      result = response.data;
    })
    .catch(error => {
      result = error;
    });
  return result;
};

export const deleteEcosytemIntegator = async (id) => {
  try {
    const response = await apiService.patch(`${apiEndPoints.deleteEcosytemIntegator}/${id}/status/DELETED`, '');
    return response;
  } catch (error) {
    return error;
  }
};

export const ecosytemIntegatorMetaData = async () => {
  let result;
  await apiService.get(`${apiEndPoints.ecosytemIntegatorMetaData}`)
    .then((response) => {
      result = response.data;
    })
    .catch(error => {
      result = error;
    });
  return result;
};


export const countryMetaData = async () => {
  let result;
  await apiService.get(`${apiEndPoints.countryMetaData}`)
    .then((response) => {
      result = response.data;
    })
    .catch(error => {
      result = error;
    });
  return result;
};